/**
 * Which URLs belong to the world. Kept free of imports so the main chunk can ask
 * without pulling world content or assets into it.
 */
export const WORLD_PATH = /^\/(services|work|projects|products|people|about|media|contact|ai-readiness)(\/|$)/;

export function isWorldPath(pathname: string): boolean {
  if (pathname === '/') return true;
  if (pathname.startsWith('/ai-readiness/audit')) return false;
  return WORLD_PATH.test(pathname);
}
